<template>
    <div v-show="visible">
        <el-dialog title="选择指标" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="650px">    
            <div class="container">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="queryForm.title" placeholder="指标名称"></el-input>
                    </div>
                </div>
                <el-button type="primary" icon="search" @click="getData()">查询</el-button>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  @click="add()">完成</el-button>
                </div>

                <el-table
                    :data="data"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="id"
                    v-loading="loading"
                    height="330"
                    element-loading-background = "rgba(255, 255,255,0.7)"
                    element-loading-text = "数据正在加载中..."
                    border
                    fit highlight-current-row
                    :tree-props="{children: 'children'}"
                    @row-click="handleSelectionChange">
                    <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                    <el-table-column prop="text" label="目录/指标名"  :show-overflow-tooltip="true"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../../common/http';

    export default {
        data(){
            return{
                loading:false,
                visible:false,
                common:{
                    checkboxArr:[]
                },
                queryForm:{
                    id:"",
                    deptId:"",
                    title:""
                },
                tableForm:{
                    id:"",
                    title:"",
                    indicatorsType:"",
                },
                data: [],
                parentData: []
            }
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(deptId, parentData){
                // 初始值 
                this.visible=true
                this.queryForm.deptId = deptId
                this.parentData = parentData
                this.queryForm.title = ""
                this.tableForm.indicatorsType = ""
                
                // 获取数据列表
                this.getData();
            },
            indexMethod(index) {
                return (index+1);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                this.data = []
                this.loading=true
                let url  = this.evaluateIndicatorsDefineTreeListUrl2
                let data = {
                    deptId:this.queryForm.deptId,
                    title:this.queryForm.title,
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            handleSelectionChange(row, column, event){
                this.tableForm.id = row.id;
                this.tableForm.title = row.text;
                this.tableForm.indicatorsType = row.attributes.indicatorsType
            },
            // 添加指标值
            add(){
                // 指标类型（1-目录 ， 2-指标）
                if(this.tableForm.indicatorsType==''){
                    this.$commonFn.showTip('请选择指标',3)
                }else if(this.tableForm.indicatorsType == 1){
                    this.$commonFn.showTip('该选项是目录非指标，请选择指标',3)
                }else{
                    this.parentData.indexId = this.tableForm.id
                    this.parentData.indexLabel = this.tableForm.title
                    this.visible=false;
                }
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/dingdingAttendance/components/indicatorsDefine.vue